var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaWrist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_3730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_3730)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9711,
    cy: 26.057,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685715,
    transform: "matrix(-0.866026 0.5 0.5 0.866025 32.3535 28.9023)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.8672,
    y: 28.0117,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685715,
    transform: "rotate(-90 32.8672 28.0117)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.1318,
    y: 18.9595,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(90 15.1318 18.9595)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 15.6465 18.0688)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0551 18.9927C24.1456 19.0451 24.244 19.0695 24.3417 19.0695C24.54 19.0695 24.7333 18.9668 24.8403 18.7822C24.9991 18.507 24.905 18.1557 24.6298 17.9969C19.942 15.2905 20.3127 10.7471 20.6899 8.91936C20.7538 8.60828 20.5541 8.30437 20.243 8.24043C19.9319 8.17649 19.628 8.37622 19.5641 8.6873C19.3773 9.59183 19.1387 11.4016 19.6373 13.3637C19.9139 14.4528 20.373 15.4378 21.0089 16.315L9.04029 31.2522C8.842 31.5001 8.88151 31.8615 9.12938 32.0605C9.23571 32.1452 9.36215 32.1869 9.4886 32.1869C9.65672 32.1869 9.82411 32.1129 9.93763 31.9714L21.7611 17.2152C22.4019 17.8863 23.1671 18.4804 24.0551 18.9927ZM41.182 16.9897C40.914 16.8201 40.5591 16.8998 40.3888 17.1678C40.3787 17.1836 39.3593 18.7757 37.4676 20.0603C34.9552 21.7666 32.1906 22.1136 29.2507 21.092C28.9504 20.9878 28.6235 21.1466 28.5194 21.4462C28.4152 21.7458 28.574 22.0734 28.8736 22.1775C29.6682 22.4534 30.4268 22.6287 31.1496 22.7221L23.4903 39.2981C23.3573 39.5862 23.4831 39.9274 23.7712 40.0611C23.8495 40.097 23.9314 40.1142 24.0118 40.1142C24.2288 40.1142 24.4372 39.9907 24.5342 39.7802L32.3774 22.8055H32.4449C34.8532 22.8055 36.7765 21.9189 38.1142 21.0101C40.2013 19.5926 41.3149 17.8547 41.3616 17.7814C41.5311 17.5134 41.4514 17.1585 41.1834 16.9882L41.182 16.9897ZM24.2338 31.6488C24.1311 31.8449 23.9314 31.9577 23.7237 31.9577C23.6347 31.9577 23.5434 31.9369 23.4586 31.8924C23.1777 31.7458 23.0685 31.3988 23.2151 31.1172L27.0142 23.8336C27.1608 23.5527 27.5078 23.4434 27.7894 23.59C28.0703 23.7366 28.1795 24.0836 28.033 24.3652L24.2338 31.6488Z",
    fill: "#536479"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaWrist);
export default __webpack_public_path__ + "static/media/ja_wrist.553b8eaed71e4f8b2e4664327326730c.svg";
export { ForwardRef as ReactComponent };